import React from 'react';
import AlanButtonOptions from '../AlanButtonOptions/AlanButtonOptions';
import store from '../../../../store';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import ComboBox from '../../../components/ComboBox/ComboBox';
import EnvironmentItem from '../../../components/EnvironmentItem/EnvironmentItem';
import menuItems from '../../../../const/menuItems';
import environmentTitleMap from '../../../../const/environmentTitleMap';
import ToasterService from '../../../../services/ToasterService';
import canChangeEnvironment from '../../../../services/mini/canChangeEnvironment';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import servers from '../../../../const/servers';
import platformNames from '../../../../const/platformNames';
import EmbedCodeCopyButton from '../EmbedCodeCopyButton/EmbedCodeCopyButton';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import { TabsComponent } from '../../../components/TabsComponent/Tabs';
import { AndroidTab } from './tabs/AndroidTab';
import { IosTab } from './tabs/IosTab';
import { WebTab } from './tabs/WebTab';
import { ReactTab } from './tabs/ReactTab';
import { AngularTab } from './tabs/AngularTab';
import { VueTab } from './tabs/VueTab';
import { ElectronTab } from './tabs/ElectronTab';
import { IonicTab } from './tabs/IonicTab';
import { EmberTab } from './tabs/EmberTab';
import { ObjectiveCTab } from './tabs/ObjectiveCTab';
import { ReactNativeTab } from './tabs/ReactNativeTab';
import { KotlinTab } from './tabs/KotlinTab';
import { FlutterTab } from './tabs/FlutterTab';
import angularLogo from '../../../../assets/images/embed/framework_logos/angular.svg';
import electronLogo from '../../../../assets/images/embed/framework_logos/electron.svg';
import emberLogo from '../../../../assets/images/embed/framework_logos/ember.svg';
import ionicLogo from '../../../../assets/images/embed/framework_logos/ionic.svg';
import jsLogo from '../../../../assets/images/embed/framework_logos/js.svg';
import reactLogo from '../../../../assets/images/embed/framework_logos/react.svg';
import vueLogo from '../../../../assets/images/embed/framework_logos/vue.svg';
import swiftLogo from '../../../../assets/images/embed/framework_logos/swift.svg';
import kotlinLogo from '../../../../assets/images/embed/framework_logos/kotlin.svg';
import flutterLogo from '../../../../assets/images/embed/framework_logos/flutter.svg';
import javaLogo from '../../../../assets/images/embed/framework_logos/java.svg';
import AlanButtonVoicesForm from '../AlanButtonVoicesForm/AlanButtonVoicesForm';
import _ from 'lodash';
import CohortsForm from '../Cohorts/CohortsForm/CohortsForm';
import WakeWordOptions from '../WakeWordOptions/WakeWordOptions';
import VisualStyleOptions from '../VisualStyleOptions/VisualStyleOptions';
import AlanButtonExtensionForm from '../AlanButtonExtensionForm/AlanButtonExtensionForm';
import AlanButtonModesForm from '../AlanButtonModesForm/AlanButtonModesForm';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import cohortHelper from '../../../../services/CohortHelper';
import messages from '../../../../const/messages';
require('codemirror/mode/htmlmixed/htmlmixed');


export const EMBED_TRANSITION_TIME = 750;

const platforms = {
    web: 'web',
    ios: 'ios',
    android: 'android',
};

const webTabs = [
    {
        title: 'JavaScript',
        image: jsLogo,
        docs: `${menuItems.docs.href}/client-api/web/web-api`,
        documentationTitle: 'JavaScript',
    },
    {
        title: 'React',
        image: reactLogo,
        docs: `${menuItems.docs.href}/client-api/web/react`,
        documentationTitle: 'React',
    },
    {
        title: 'Angular',
        image: angularLogo,
        docs: `${menuItems.docs.href}/client-api/web/angular`,
        documentationTitle: 'Angular',
    },
    {
        title: 'Vue',
        image: vueLogo,
        docs: `${menuItems.docs.href}/client-api/web/vue`,
        documentationTitle: 'Vue',
    },
    {
        title: '',
        image: emberLogo,
        docs: `${menuItems.docs.href}/client-api/web/ember`,
        documentationTitle: 'Ember',
    },
    {
        title: 'Electron',
        image: electronLogo,
        docs: `${menuItems.docs.href}/client-api/web/electron`,
        documentationTitle: 'Electron',
    },
    {
        title: 'Ionic',
        image: ionicLogo,
        docs: `${menuItems.docs.href}/client-api/cross-platform/ionic`,
        documentationTitle: 'Ionic',
    },
];

const iosTab = [
    {
        title: 'Swift',
        image: swiftLogo,
        docs: `${menuItems.docs.href}/client-api/ios/ios-api#integrate-with-swift`,
        documentationTitle: 'Swift',
    },
    {
        title: 'Objective-C',
        image: null,
        docs: `${menuItems.docs.href}/client-api/ios/ios-api#integrate-with-objective-c`,
        documentationTitle: 'Objective-C',
    },
    {
        title: 'Ionic',
        image: ionicLogo,
        docs: `${menuItems.docs.href}/client-api/cross-platform/ionic`,
        documentationTitle: 'Ionic',
    },
    {
        title: 'Flutter',
        image: flutterLogo,
        docs: `${menuItems.docs.href}/client-api/cross-platform/flutter`,
        documentationTitle: 'Flutter',
    },
    {
        title: 'React Native',
        image: reactLogo,
        documentationTitle: 'React Native',
        docs: `${menuItems.docs.href}/client-api/cross-platform/react-native`,
    },
];

const androidTabs = [
    {
        title: 'Java',
        image: javaLogo,
        docs: `${menuItems.docs.href}/client-api/android/android-api`,
        documentationTitle: 'Java',
    },
    {
        title: 'Kotlin',
        image: kotlinLogo,
        docs: `${menuItems.docs.href}/client-api/android/android-api`,
        documentationTitle: 'Kotlin',
    },
    {
        title: 'Ionic',
        image: ionicLogo,
        docs: `${menuItems.docs.href}/client-api/cross-platform/ionic`,
        documentationTitle: 'Ionic',
    },
    {
        title: 'Flutter',
        image: flutterLogo,
        docs: `${menuItems.docs.href}/client-api/cross-platform/flutter`,
        documentationTitle: 'Flutter',
    },
    {
        title: 'ReactNative',
        image: reactLogo,
        documentationTitle: 'ReactNative',
        docs: `${menuItems.docs.href}/client-api/cross-platform/react-native`,
    },
];

const DEFAULT_COHORT_ID = 'default';
const ADD_EDIT_COHORT_ID = 'add_edit_cohort';

class EmbedCodeForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { environment } = this.props;

        this.state = {
            environment: environment,
            activeTab: platforms.web,
            initialForm: true,
            optionsMode: false,
            voicesForm: false,
            cohortsForm: false,
            wakeWordForm: false,
            extensionForm: false,
            modesForm: false,
            selectedCohortId: DEFAULT_COHORT_ID,
            showInitialForm: true,
            creatingCohort: false,
            visualStyleForm: false,
            ...this.getFrameWorkTabState(platforms.web),
        };
    }

    componentDidMount() {
        this.fillData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.project.projectId !== prevProps.project.projectId) {
            this.fillData();
        }

        if (prevState.initialForm !== this.state.initialForm) {
            const showInitialForm = this.state.initialForm;
            if (this.state.initialForm) {
                this.setState({
                    showInitialForm,
                });
            } else {
                setTimeout(() => {
                    this.setState({
                        showInitialForm,
                    });
                }, EMBED_TRANSITION_TIME);
            }
        }
    }

    fillInitialCohortId(environment) {
        const { projectId, cohorts } = this.props;
        if (cohorts.length > 0) {
            let savedCohortId = cohortHelper.getCurrentCohort(projectId, environment);
            if (_.find(this.getCohortsByEnvironment(environment), { id: savedCohortId })) {
                return savedCohortId;
            }
        }

        return DEFAULT_COHORT_ID;
    }

    fillData() {
        const { getCohorts, projectId, cohortsAvailable, getWakeWords } = this.props;
        const { selectedCohortId, environment } = this.state;
        if (cohortsAvailable) {
            getCohorts({ projectId }).then((cohorts) => {
                if (selectedCohortId === DEFAULT_COHORT_ID && cohorts.length > 0) {
                    this.setState({ selectedCohortId: this.fillInitialCohortId(environment) });
                }
            });
        }
        getWakeWords({ projectId });
    }

    onEnvironmentSelect = (environmentObj) => {
        const { tier, project, rememberProjectEnvironment } = this.props;
        const newEnvironment = environmentObj.key;
        if (canChangeEnvironment(tier, environmentObj.key)) {

            this.setState({
                environment: newEnvironment,
            }, () => {
                this.setState({
                    selectedCohortId: this.fillInitialCohortId(newEnvironment)
                });
            });
            rememberProjectEnvironment({
                projectId: project.projectId,
                environment: newEnvironment
            });
        }
    }

    activateTab = (tabName) => {
        this.setState({
            activeTab: tabName,
            ...this.getFrameWorkTabState(tabName),
        });
    }

    onTabChange = ({ index }) => {
        this.setState({
            frameWorkCurrentTabIndex: index,
        });
    };

    getFrameWorkTabState(activeTab) {
        switch (activeTab) {
            case platforms.web:
                return {
                    frameWorkTabs: webTabs,
                    frameWorkCurrentTabIndex: 0,
                };
            case platforms.ios:
                return {
                    frameWorkTabs: iosTab,
                    frameWorkCurrentTabIndex: 0,
                };
            case platforms.android:
                return {
                    frameWorkTabs: androidTabs,
                    frameWorkCurrentTabIndex: 0,
                };
            default:
                return {
                    frameWorkTabs: webTabs,
                    frameWorkCurrentTabIndex: 0,
                };
        }
    }

    addCohort = () => {
        const {
            project,
            cohorts,
            createCohort
        } = this.props;

        const { environment } = this.state;

        if (this.needAddCohort()) {
            this.setState({ creatingCohort: true }, () => {
                createCohort({
                    project,
                    environment,
                    cohorts
                }).then(({ id }) => {
                    this.setState({ selectedCohortId: id, creatingCohort: false }, () => {
                        this.openCohorts();
                    });
                }, () => {
                    this.setState({ creatingCohort: false });
                });
            });
        } else {
            this.openCohorts();
        }
    }

    openCohorts = () => {
        this.setState({
            initialForm: false,
            voicesForm: false,
            optionsMode: false,
            cohortsForm: true,
            wakeWordForm: false,
        });
    }

    closeCohortsForm = () => {
        this.setState({ initialForm: true }, () => {
            setTimeout(() => {
                this.setState({
                    cohortsForm: false,
                    voicesForm: false,
                    optionsMode: false,
                });
            }, EMBED_TRANSITION_TIME);
        });
    };

    activateVoicesForm = () => {
        this.setState({
            initialForm: false,
            voicesForm: true,
            optionsMode: false,
            cohortsForm: false,
        });
    }

    closeVoicesForm = () => {
        this.setState({ initialForm: true });
    }

    activateWakeWordForm = () => {
        this.setState({
            initialForm: false,
            voicesForm: false,
            optionsMode: false,
            cohortsForm: false,
            wakeWordForm: true
        });
    }

    closeWakeWordForm = () => {
        this.setState({ initialForm: true }, () => {
            setTimeout(() => {
                this.setState({
                    wakeWordForm: false,
                });
            }, EMBED_TRANSITION_TIME);
        });
    }

    activateVisualStyleForm = () => {
        this.setState({
            initialForm: false,
            voicesForm: false,
            optionsMode: false,
            cohortsForm: false,
            wakeWordForm: false,
            visualStyleForm: true
        });

        if (isLocalStorageAvailable()) {
            localStorage.removeItem(`alan-chat-options-scroll-top-pos`);
        }
    }

    activateExtensionForm = () => {
        this.setState({
            initialForm: false,
            voicesForm: false,
            optionsMode: false,
            cohortsForm: false,
            wakeWordForm: false,
            visualStyleForm: false,
            extensionForm: true,
        });
    }

    activateModesForm = () => {
        this.setState({
            initialForm: false,
            voicesForm: false,
            optionsMode: false,
            cohortsForm: false,
            wakeWordForm: false,
            visualStyleForm: false,
            extensionForm: false,
            modesForm: true,
        });
    }

    closeVisualStyleForm = () => {
        this.setState({ initialForm: true }, () => {
            setTimeout(() => {
                this.setState({
                    visualStyleForm: false,
                });
            }, EMBED_TRANSITION_TIME);
        });
    }

    closeExtensionForm = () => {
        this.setState({ initialForm: true }, () => {
            setTimeout(() => {
                this.setState({
                    extensionForm: false,
                });
            }, EMBED_TRANSITION_TIME);
        });
    }

    closeModesForm = () => {
        this.setState({ initialForm: true }, () => {
            setTimeout(() => {
                this.setState({
                    modesForm: false,
                });
            }, EMBED_TRANSITION_TIME);
        });
    }


    activateOptionsMode = () => {
        this.setState({
            initialForm: false,
            optionsMode: true,
            voicesForm: false,
            cohortsForm: false,
        });
    }

    closeOptionsMode = () => {
        this.setState({ initialForm: true, optionsMode: false });
    }

    resetProject = () => {
        const { resetProject } = this.props;
        resetProject().then(() => {
            ToasterService.showInfo({ title: 'Project was reset' });
        }, () => { });
    }

    selectCohort = ({ id }) => {
        const { projectId } = this.props;
        const { environment, creatingCohort } = this.state;

        if (creatingCohort) return;

        if (id === ADD_EDIT_COHORT_ID) {
            this.addCohort(id);
        } else {
            this.setState({ selectedCohortId: id });
            cohortHelper.setCurrentCohort(projectId, environment, id);
        }
    }

    selectDefaultCohort = () => {
        this.setState({ selectedCohortId: DEFAULT_COHORT_ID });
    }

    needAddCohort() {
        return this.getCohortsByEnvironment().length === 0;
    }

    getCohortsByEnvironment = () => {
        const { cohorts } = this.props;
        const { environment } = this.state;

        return cohorts.filter((cohort) => {
            return cohort.deployment.toLowerCase() === environment;
        });
    }

    extendCohortTabData() {
        const { cohortsAvailable } = this.props;
        const { creatingCohort } = this.state;
        return {
            disabled: !cohortsAvailable || creatingCohort,
            tooltip: !cohortsAvailable ? messages.featureNotAvailable : null
        };
    }

    getCohortsForTabs() {
        return [
            { name: 'Default', id: DEFAULT_COHORT_ID },
            ...this.getCohortsByEnvironment().map(cohort => {
                return {
                    ...cohort,
                    ...this.extendCohortTabData()
                };
            }),
            {
                name: 'Add / Edit cohorts',
                id: ADD_EDIT_COHORT_ID,
                ...this.extendCohortTabData()
            }
        ];
    }

    render() {
        const {
            project,
            isProjectResetting,
            projectId,
            cohorts,
            isProjectOptionsSaving
        } = this.props;

        const {
            activeTab,
            initialForm,
            optionsMode,
            voicesForm,
            cohortsForm,
            wakeWordForm,
            visualStyleForm,
            extensionForm,
            modesForm,
            environment,
            frameWorkCurrentTabIndex,
            selectedCohortId,
            showInitialForm,
        } = this.state;

        const cohortsByEnvironment = this.getCohortsByEnvironment();

        const key = `${project.projectId}/${environment}`;

        const cohortTabs = this.getCohortsForTabs();
        const selctedCohort = _.find(cohortTabs, { id: selectedCohortId });

        return <div className="embed-code-form-container">
            <div
                className={`embed-code-form-content ${(!initialForm) ? 'embed-code-form-content_to-right' : 'embed-code-form-content_to-left'}`}>
                <div className={`embed-code-form-holder`}>
                    <PopupWrapper className={`embed-code-form ${environment}  ${!showInitialForm && 'embed-code-form-holder_hidden'} ${isProjectOptionsSaving && 'disabled-options'}`}>
                        <div className="popup-form_header popup-form_header_with-commands">
                            <div className="embed-code-form_header">
                                <div className="embed-code-form_header-col">
                                    <span className="embed-code-form__title">Integrations</span>
                                    <ComboBox
                                        values={servers}
                                        valueKey="key"
                                        valueName="name"
                                        selectedValueId={environment}
                                        onValueSelect={this.onEnvironmentSelect}
                                        environmentItem={true}
                                        classes={`embed-code-form_server-combo-box ${environment}`}
                                        renderItem={(serverItem) => {
                                            return <EnvironmentItem serverItem={serverItem} project={project} />;
                                        }} />
                                </div>
                            </div>
                            <div className="popup-form_header_cmd">
                                <a className="embed-code-form__link" target="_blank" rel="noreferrer" title="View Documentation" href={`${menuItems.docs.href}/usage/button/customization`}><i className="icon icon-alan-help-sign" /> View documentation</a>
                            </div>
                        </div>
                        <div className="popup-form_internal-wrapper">
                            <div className="popup-form_internal-wrapper_info">
                                <b>Alan SDK Key</b>
                                <div className="popup-form_internal-wrapper_info_fields">
                                    <input readOnly={true} value={key} className="embed-code-form_key" />
                                    <EmbedCodeCopyButton text="Copy SDK Key" code={key} className="big embed-code-copy-btn_no-margin" />
                                </div>
                            </div>

                            <TabsComponent
                                tabs={cohortTabs}
                                currentTabId={selectedCohortId}
                                className="embed-code-form_cohort-tabs"
                                valueName="name"
                                valueKey="id"
                                onChange={this.selectCohort} />

                            <div className="embed-code-form_options-holder">
                                <div className="embed-code-form_options-holder-header">
                                    <div className="embed-code-form_active-cohort-panel-info">
                                        {selectedCohortId === DEFAULT_COHORT_ID ?
                                            'Options for users in the Default cohort' :
                                            `Options for users in ${selctedCohort?.name}`}
                                    </div>
                                    <a
                                        className="embed-code-form__link embed-code-form__cohorts-doc"
                                        target="_blank"
                                        rel="noreferrer"
                                        title="View Cohorts Documentation"
                                        href={`${menuItems.docs.href}/usage/button/cohorts`}>
                                        <i className="icon icon-alan-help-sign" />
                                        View documentation
                                    </a>
                                </div>

                                <div className="embed-code-form_tabs">
                                    {Object.keys(platforms).map(platform => {
                                        return <div key={platform}
                                            className={`embed-code-form_tab ${platform} ${(activeTab === platform && 'active')} ${environment}`}
                                            onClick={() => this.activateTab(platform)}>
                                            {platformNames[platform]}
                                        </div>;
                                    })}
                                </div>

                                <div className="embed-code-form_more-settings">
                                    <AlanButtonOptions
                                        key={`${activeTab}-${environment}-${optionsMode}-${selectedCohortId}`}
                                        store={store}
                                        optionsMode={optionsMode}
                                        platform={activeTab}
                                        environment={environment}
                                        project={project}
                                        projectId={projectId}
                                        openOptions={this.activateOptionsMode}
                                        openVoicesForm={this.activateVoicesForm}
                                        openWakeWordSettings={this.activateWakeWordForm}
                                        openVisualStyleSettings={this.activateVisualStyleForm}
                                        openExtensionSettings={this.activateExtensionForm}
                                        openModesSettings={this.activateModesForm}
                                        cohorts={cohorts}
                                        selectedCohortId={selectedCohortId} />
                                </div>
                            </div>
                            <div className="embed-code-form_tab-wrapper_header">
                                <span className="embed-code-form__title">Embed Code Example</span>
                                {activeTab && isFinite(frameWorkCurrentTabIndex) && this.state.frameWorkTabs[frameWorkCurrentTabIndex].docs &&
                                    <a
                                        className="embed-code-form__link"
                                        target="_blank"
                                        rel="noreferrer"
                                        title={`View ${environmentTitleMap[activeTab]} Documentation`}
                                        href={this.state.frameWorkTabs[frameWorkCurrentTabIndex].docs}>
                                        <i className="icon icon-alan-help-sign" />
                                        View {this.state.frameWorkTabs[frameWorkCurrentTabIndex].documentationTitle} documentation
                                    </a>
                                }
                            </div>
                            <TabsComponent
                                valueName="title"
                                valueKey="index"
                                tabs={this.state.frameWorkTabs}
                                currentTabIndex={this.state.frameWorkCurrentTabIndex}
                                onChange={this.onTabChange} />
                            <div className="embed-code-form_tab-wrapper">
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 0 && <WebTab alanKey={key} />}
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 1 && <ReactTab alanKey={key} />}
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 2 && <AngularTab alanKey={key} />}
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 3 && <VueTab alanKey={key} />}
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 4 && <EmberTab alanKey={key} />}
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 5 && <ElectronTab alanKey={key} />}
                                {activeTab === platforms.web && frameWorkCurrentTabIndex === 6 && <IonicTab alanKey={key} />}
                                {activeTab === platforms.ios && frameWorkCurrentTabIndex === 0 && <IosTab alanKey={key} />}
                                {activeTab === platforms.ios && frameWorkCurrentTabIndex === 1 && <ObjectiveCTab alanKey={key} />}
                                {activeTab === platforms.ios && frameWorkCurrentTabIndex === 2 && <IonicTab alanKey={key} />}
                                {activeTab === platforms.ios && frameWorkCurrentTabIndex === 3 && <FlutterTab alanKey={key} />}
                                {activeTab === platforms.ios && frameWorkCurrentTabIndex === 4 && <ReactNativeTab alanKey={key} />}
                                {activeTab === platforms.android && frameWorkCurrentTabIndex === 0 && <AndroidTab alanKey={key} />}
                                {activeTab === platforms.android && frameWorkCurrentTabIndex === 1 && <KotlinTab alanKey={key} />}
                                {activeTab === platforms.android && frameWorkCurrentTabIndex === 2 && <IonicTab alanKey={key} />}
                                {activeTab === platforms.android && frameWorkCurrentTabIndex === 3 && <FlutterTab alanKey={key} />}
                                {activeTab === platforms.android && frameWorkCurrentTabIndex === 4 && <ReactNativeTab alanKey={key} />}
                            </div>
                            <div className="embed-code-form_bottom-btns">
                                {window.tutorProject &&
                                    <div
                                        className={`action-btn light-red-with-border embed-code-form_reset-btn ${isProjectResetting && 'disabled'}`}
                                        onClick={this.resetProject}
                                        title="Restart the dialog container on the server">
                                        Restart Virtual Machine
                                    </div>
                                }
                            </div>
                        </div>
                    </PopupWrapper>
                </div>
                <div className="embed-code-form_form-separator" />
                <div className={`embed-code-form-holder ${isProjectOptionsSaving && 'disabled-options'}`}>
                    {voicesForm &&
                        <AlanButtonVoicesForm
                            key={`voices-${activeTab}-${environment}-${selectedCohortId}`}
                            platform={activeTab}
                            environment={environment}
                            projectId={projectId}
                            project={project}
                            onClose={this.closeVoicesForm}
                            cohorts={cohorts}
                            selectedCohortId={selectedCohortId} />}
                    {cohortsForm &&
                        <CohortsForm
                            key={`cohorts-${activeTab}-${environment}-${selectedCohortId}`}
                            platform={activeTab}
                            environment={environment}
                            projectId={projectId}
                            project={project}
                            cohorts={cohortsByEnvironment}
                            selectedCohortId={selectedCohortId}
                            onCohortDeleted={this.selectDefaultCohort}
                            onCohortSelected={this.selectCohort}
                            onClose={this.closeCohortsForm} />}
                    {wakeWordForm &&
                        <WakeWordOptions
                            key={`wake-word-${activeTab}-${environment}-${selectedCohortId}`}
                            platform={activeTab}
                            environment={environment}
                            projectId={projectId}
                            project={project}
                            onClose={this.closeWakeWordForm}
                            cohorts={cohorts}
                            selectedCohortId={selectedCohortId} />}
                    {visualStyleForm &&
                        <VisualStyleOptions
                            key={`text-chat-${activeTab}-${environment}-${selectedCohortId}`}
                            platform={activeTab}
                            environment={environment}
                            projectId={projectId}
                            project={project}
                            onClose={this.closeVisualStyleForm}
                            cohorts={cohorts}
                            selectedCohortId={selectedCohortId} />}
                    {extensionForm &&
                        <AlanButtonExtensionForm
                            key={`alan-extension-${activeTab}-${environment}-${selectedCohortId}`}
                            platform={activeTab}
                            environment={environment}
                            projectId={projectId}
                            project={project}
                            onClose={this.closeExtensionForm}
                            cohorts={cohorts}
                            selectedCohortId={selectedCohortId} />}
                    {modesForm &&
                        <AlanButtonModesForm
                            key={`alan-modes-${activeTab}-${environment}-${selectedCohortId}`}
                            platform={activeTab}
                            environment={environment}
                            projectId={projectId}
                            project={project}
                            onClose={this.closeModesForm}
                            cohorts={cohorts}
                            selectedCohortId={selectedCohortId} />}
                </div>
            </div>
        </div>;
    }
}

function mapStateToProps({ projectsInfo, user }) {
    return {
        cohorts: projectsInfo.currentProject.cohorts,
        cohortsAvailable: user.capabilities.cohortsAvailable,
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getWakeWords: (param) => asyncDispatch(actions.getWakeWords, dispatch, param),
        getCohorts: (param) => asyncDispatch(actions.getCohorts, dispatch, param),
        createCohort: (param) => asyncDispatch(actions.createCohort, dispatch, param),
        rememberProjectEnvironment: (param) => dispatch(actions.rememberProjectEnvironment(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedCodeForm);
